import map from "lodash/map";
import { ContentFormatV6 } from "../v6/content_format";
import { ContentConditionV6, TemplateFormatV6 } from "../v6/template_format";
import { ContentFormatV7 } from "../v7/content_format";
import { ContentConditionV7, TemplateFormatV7 } from "../v7/template_format";

export function upgradeContentToV7(contentFormat: ContentFormatV6): ContentFormatV7 {
  return {
    ...contentFormat,
    definition_version: 7,

    pages: map(contentFormat.pages, (pageContent) => {
      return pageContent;
    }),
  };
}

export function upgradeTemplateToV7(templateFormat: TemplateFormatV6): TemplateFormatV7 {
  return {
    ...templateFormat,
    definition_version: 7,

    content_page_configuration: {
      force_pack_color: false,
      forced_layouts: templateFormat.content_page_configuration.forced_layouts.map(
        (forcedLayout) => {
          return {
            ...forcedLayout,
            description: [],
          };
        }
      ),
      add_next: {
        filter_type: templateFormat.content_page_configuration.add_next.filter_type,
        description: [],
      },
    },

    page_definitions: templateFormat.page_definitions.map((definition) => {
      const conditionsV6ToV7 = (conditions: ContentConditionV6[]): ContentConditionV7[] => {
        return conditions.map((condition) => {
          return {
            ...condition,
            variable:
              condition.variable === "book_front_cover_page_definition_key"
                ? "page_definition_key"
                : condition.variable,
          };
        });
      };

      return {
        ...definition,
        elements: definition.elements.map((element) => {
          return {
            ...element,
            conditions: element.conditions
              ? conditionsV6ToV7(element.conditions)
              : element.conditions,
          };
        }),
        conditions: definition.conditions
          ? conditionsV6ToV7(definition.conditions)
          : definition.conditions,
      };
    }),
  };
}
